module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel05_1280_1280_zh-hant-f317a21d5c514b9ebfd1c55c3a4dafc2.jpg";